export default __webpack_public_path__ + "static/media/SB_logo.2eff7f16.svg";